<template>
  <div>
    <div class="back" @click="$router.go(-1)"></div>
    <div class="wrapper">
      <h1>Manually Add</h1>
      <div class="input">
        <p>RTSP://</p>
        <div class="input-container">
      <input type="email" placeholder="RTSP" v-model="rtsp" />
      </div>
      </div>
       <div class="input">
        <p>Camera Name</p>
        <div class="input-container">
      <input type="email" placeholder="Camera name" v-model="friendlyName" />
      </div>
      </div>
      <div class="input">
        <p>Username</p>
        <div class="input-container">
      <input type="email" placeholder="Username" v-model="username" />
      </div>
      </div>
      <div class="input">
        <p>Password</p>
        <div class="input-container">
      <input type="email" placeholder="Password" v-model="password" />
      </div>
      </div>

      <button @click="addCamera" :disabled="loading">
        <p v-if="!loading">Add</p> <loading-wheel v-else /> </button>
    </div>
  </div>
</template>

<script>
import awsInfo from '../../public/websocket';
import LoadingWheel from '../components/LoadingWheel.vue';

export default {
  components: { LoadingWheel },
  data() {
    return {
      rtsp: '',
      username: '',
      password: '',
      friendlyName: '',
      mac: '',
      type: 'IP',
      url: '',
      enable_video: true,
      enable_audio: false,
      location: '',
      loading: false,
    };
  },

  computed: {
    changeRoute() {
      return this.$store.state.changeRoute;
    },
    device() {
      return this.$store.getters.deviceId(this.$route.params.device);
    },
  },
  methods: {
    addCamera() {
      if (this.rtsp === '' || this.username === '' || this.password === '' || this.friendlyName === '') {
        this.$store.dispatch('addNotification', {
          type: 'red',
          title: 'Please fill fields',
          comment: '',
        });
        return;
      }
      this.loading = true;
      awsInfo.addCamera(this.device.id, this.friendlyName, this.type, this.rtsp,
        this.location, this.username, this.password, this.enable_video, this.enable_audio);
      const cameraData = {
        deviceId: this.device.id,
        name: this.friendlyName,
        type: this.type,
        url: this.rtsp,
        username: this.username,
        password: this.password,
        audio: this.enable_audio,
        video: this.enable_video,
      };
      this.$store.dispatch('setAddCamera', cameraData);
    },
  },
  watch: {
    changeRoute(value) {
      if (value !== false) {
        this.$router.push({ name: 'AddCamera', params: { id: this.device.id } });
      }
    },
  },

};
</script>

<style scoped>
button {
  margin-top: 50px;
  width: 126px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}
.input:nth-of-type(3) {
  margin-top: 50px;
}
h1 {
  margin-top: 20px;
    font-weight: 500;
    font-size: 24px;
  margin-bottom: 28px;
}
.wrapper {
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
